import {useMemo} from 'react';
import {bulkUpdateStaticSchema} from '../bulkUpdateSchemas';
import type {BulkUpdateValuesProps} from './useBulkUpdateValuesSchema';
import {useBulkUpdateValuesSchema} from './useBulkUpdateValuesSchema';

export const useBulkUpdateSchema = (props: BulkUpdateValuesProps) => {
  const valuesSchema = useBulkUpdateValuesSchema(props);
  return useMemo(
    () => ({
      name: 'bulkUpdate',
      parts: [...bulkUpdateStaticSchema.parts, ...valuesSchema.parts],
    }),
    [valuesSchema],
  );
};
